import Http from './Http';
import axios from "axios";

export const getTranslateCheetah = lang => {

    let url = 'https://cheetah-api.builderall.com/api/';

    let http = axios.create({
        baseURL: url,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    });

    return http.get(`/translate/translations/responsive/${lang}`);
};


export const getRestrictAreas = data => Http.authApi().get(`restrict-areas`, data);